import { render, staticRenderFns } from "./appr-kick.vue?vue&type=template&id=c0c691ec&scoped=true"
import script from "./appr-kick.vue?vue&type=script&lang=js"
export * from "./appr-kick.vue?vue&type=script&lang=js"
import style0 from "./appr-kick.vue?vue&type=style&index=0&id=c0c691ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c691ec",
  null
  
)

export default component.exports